import { logEvent } from '@library/utilities/userLogsEvents/userLogEvents'
import { ArrowRightOutlined, Button, Col, Row } from 'gokwik-ui-kit'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getMerchantDetails, getUserDetails } from '@store/user/selectors'

export default function OnboardStep1({ startPolling, website }) {
    const merchant_details = useSelector(getMerchantDetails)
    const userDetails = useSelector(getUserDetails)

    useEffect(() => {
        logEvent(
            'cod_app_installation_page_landed',
            'event',
            'onboarding',
            userDetails?.email,
            merchant_details?.m_id,
            merchant_details?.short_name,
            userDetails?.name,
        )
    }, [])
    return (
        <Row className='bg-white p-4 py-6 border-solid border-gray-100 rounded-md '>
            <Col span={12}>
                <iframe
                    width='100%'
                    height='360'
                    src='https://www.youtube.com/embed/HVZiq1ksmPg?autoplay=1&mute=1'
                    className='rounded-xl'
                    allow='autoplay; encrypted-media'
                    allowFullScreen
                    title='video'
                ></iframe>
            </Col>

            <Col span={12}>
                <div className='bg-white w-full p-4 h-full'>
                    <p className='text-gray-900 font-inter text-xl font-semibold leading-7'>
                        Get Started with GoKwik COD
                    </p>
                    <p className='text-gray-400 mt-2'>
                        First step to offering COD is installing the app. You'll be able to activate it and configure
                        settings in the next steps.
                    </p>
                    <ul className='mt-12 list-none p-0 '>
                        <li className='text-gray-800 flex'>
                            <ArrowRightOutlined className='text-lg text-black' />{' '}
                            <p className='pl-3'>
                                Click the “Install GoKwik Cash on Delivery” button below to navigate to the Shopify app
                                store.
                            </p>
                        </li>
                        <br />
                        {/* <li className='text-gray-800 flex py-5'>
                            <ArrowRightOutlined className='text-lg text-black' />{' '}
                            <p className='pl-3'>Make sure you’re signed in to your Shopify account to proceed.</p>
                        </li> */}
                        <li className='text-gray-800 flex'>
                            <ArrowRightOutlined className='text-lg text-black' />{' '}
                            <p className='pl-3'>Hit the Install button and accept the access request for the app</p>
                        </li>
                        <li className='text-gray-800 flex py-5'>
                            <ArrowRightOutlined className='text-lg text-black' />{' '}
                            <p className='pl-3'>
                                Once installed, return to this tab to continue with the next steps of your journey.
                            </p>
                        </li>
                    </ul>
                    <Button
                        onClick={() => {
                            logEvent(
                                'install_cod_app_clicked',
                                'event',
                                'onboarding',
                                userDetails?.email,
                                merchant_details?.m_id,
                                merchant_details?.short_name,
                                userDetails?.name,
                            )
                            startPolling()
                        }}
                        href='https://apps.shopify.com/cash-on-delivery-by-gokwik'
                        target='_blank'
                        variant='primary'
                        className='flex justify-center items-center w-3/5'
                    >
                        {/* <span className='pl-2'>Install GoKwik Cash on Delivery App</span> */}
                        <div className='flex gap-1'>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                x='0px'
                                y='0px'
                                width='24'
                                height='24'
                                viewBox='0,0,256,256'
                            >
                                <g
                                    fill='#ffffff'
                                    fill-rule='nonzero'
                                    stroke='none'
                                    stroke-width='1'
                                    stroke-linecap='butt'
                                    stroke-linejoin='miter'
                                    stroke-miterlimit='10'
                                    stroke-dasharray=''
                                    stroke-dashoffset='0'
                                    font-family='none'
                                    font-weight='none'
                                    font-size='none'
                                    text-anchor='none'
                                    style={{ mixBlendMode: 'normal' }}
                                >
                                    <g transform='scale(5.12,5.12)'>
                                        <path d='M22.83984,2.03516c-3.18069,-0.08666 -6.5143,4.15586 -8.31055,10.68555l-5.64453,1.83984c-0.367,0.12 -0.63359,0.43927 -0.68359,0.82226l-3.44531,26.81055c-0.067,0.525 0.28564,1.01138 0.80664,1.10938l24.06836,4.58008l1.85742,-40.68555l-1.11133,0.36133c-0.663,-2.444 -1.90311,-3.98108 -3.53711,-4.33008c-0.495,-0.108 -0.9735,-0.08575 -1.4375,0.03125c-0.557,-0.588 -1.19869,-0.99339 -1.92969,-1.15039c-0.21019,-0.04488 -0.42077,-0.06844 -0.63281,-0.07422zM22.7207,4.03711c0.11516,-0.00269 0.22825,0.00667 0.33594,0.0293c0.171,0.037 0.33609,0.11284 0.49609,0.21484c-1.985,1.697 -3.50269,4.9173 -4.30469,6.9043l-2.40039,0.78125c1.635,-5.025 4.14571,-7.8894 5.87305,-7.92969zM26.65625,5.26758c0.768,0.317 1.41531,1.34916 1.82031,2.91016l-1.02344,0.33398c-0.16,-1.238 -0.42387,-2.33414 -0.79687,-3.24414zM24.75586,5.91797c0.365,0.849 0.63062,1.94766 0.76563,3.22266l-3.73047,1.21484c1.013,-2.15 2.05684,-3.6255 2.96484,-4.4375zM33.48242,7.39648l-1.8457,40.41016l12.58008,-2.7832c0.512,-0.113 0.84844,-0.60214 0.77344,-1.11914c-1.601,-11.097 -4.64031,-32.20309 -4.69531,-32.62109c-0.011,-0.1 -0.03617,-0.19801 -0.07617,-0.29101c-0.196,-0.45 -0.55044,-0.77255 -1.02344,-0.93555c-0.092,-0.031 -0.20183,-0.04874 -0.29883,-0.05274c-0.222,-0.009 -2.1942,-0.16252 -3.0332,-0.22852c-0.686,-0.701 -2.0027,-2.04256 -2.3457,-2.35156c-0.011,-0.011 -0.02416,-0.01734 -0.03516,-0.02734zM22.71875,18.02344c2.064,0 3.16198,0.64873 3.20898,0.67773c0.197,0.119 0.28584,0.36008 0.21484,0.58008l-1.51172,4.66016c-0.046,0.142 -0.15106,0.25555 -0.28906,0.31055c-0.14,0.058 -0.29578,0.04656 -0.42578,-0.02344c-0.013,-0.007 -1.28577,-0.68945 -2.75977,-0.68945c-1.783,0 -2.04883,0.91208 -2.04883,1.45508c0,0.589 0.77292,1.1727 1.66992,1.8457c1.587,1.192 3.75977,2.82361 3.75977,6.09961c0,4.104 -2.55489,6.97266 -6.21289,6.97266c-4.16,0 -6.2548,-2.59117 -6.3418,-2.70117c-0.101,-0.127 -0.13389,-0.29713 -0.08789,-0.45313l1.0625,-3.57227c0.049,-0.163 0.17975,-0.29089 0.34375,-0.33789c0.163,-0.044 0.34075,-0.00748 0.46875,0.10352c0.02,0.018 1.95719,1.71094 3.49219,1.71094c0.893,0 1.12891,-0.71575 1.12891,-1.09375c0,-0.98 -0.717,-1.57703 -1.625,-2.33203c-1.254,-1.042 -2.8125,-2.3393 -2.8125,-5.1543c0,-3.881 2.70548,-8.05664 8.64648,-8.05664c0.04,0 0.07914,-0.00195 0.11914,-0.00195z'></path>
                                    </g>
                                </g>
                            </svg>
                            Install COD Module
                        </div>
                    </Button>
                </div>
            </Col>
        </Row>
    )
}
